<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="project1">
      <input type="checkbox" class="custom-control-input mgntp10" id="project1" value="New construction" name="projecterty"
        [(ngModel)]="hgProject.project1" (click)="getProject($event)" />
      <label class="custom-control-label font20" for="project1">New construction</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="project2">
      <input type="checkbox" class="custom-control-input mgntp10" id="project2" value="Building renovation"
        name="projecterty" [(ngModel)]="hgProject.project2" (click)="getProject($event)" />
      <label class="custom-control-label font20" for="project2">Building renovation</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="project3">
      <input type="checkbox" class="custom-control-input mgntp10" id="project3" value="New location" name="projecterty"
        [(ngModel)]="hgProject.project3" (click)="getProject($event)" />
      <label class="custom-control-label font20" for="project3">New location</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="project4">
      <input type="checkbox" class="custom-control-input mgntp10" id="project4" value="Change of ownership" name="projecterty"
        [(ngModel)]="hgProject.project4" (click)="getProject($event)" />
      <label class="custom-control-label font20" for="project4">Change of ownership</label>
    </label>
  </div>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
    (click)="next();">Next</button>
</div>
<div class="container mobileview mt-1 px-0" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label class="custom-control custom-checkbox chkbox mb-2" for="project1_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="project1_mob" value="New construction"
          name="projecterty" [(ngModel)]="hgProject.project1" (click)="getProject($event)" />
        <label class="custom-control-label font20" for="project1_mob">New construction</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="project2_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="project2_mob" value="Building renovation"
          name="projecterty" [(ngModel)]="hgProject.project2" (click)="getProject($event)" />
        <label class="custom-control-label font20" for="project2_mob">Building renovation</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="project3_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="project3_mob" value="New location" name="projecterty"
          [(ngModel)]="hgProject.project3" (click)="getProject($event)" />
        <label class="custom-control-label font20" for="project3_mob">New location</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="project4_mob">
        <input type="checkbox" class="custom-control-input mgntp10" id="project4_mob" value="Change of ownership"
          name="projecterty" [(ngModel)]="hgProject.project4" (click)="getProject($event)" />
        <label class="custom-control-label font20" for="project4_mob">Change of ownership</label>
      </label>
    </div>
    <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right">
        <h1 class="ansMob text-right">{{project}}</h1>
      </div>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
            <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div>
</div>